import React, { useEffect } from "react";

import { ConfigType } from "@data-types/use-scroll-restoration/useScrollRestoration";
import { useReturnToScroll } from "@hooks/useReturnToScroll";
import { MainHtmlElementContext } from "@state/context/main-html/MainHtmlElementContext";

type Config = {
	type: ConfigType.Basic;
	isLoading?: boolean;
};

/**
 * Restores scroll position on the main element.
 *
 * pass `isLoading` to delay restoration until data is loaded.
 *
 * @param config - Configuration object.
 * @returns For `ReturnToScrollPosition`, returns a boolean flag for loader display.
 */
export function useScrollRestoration(config?: Config): boolean {
	const mainEl = React.useContext(MainHtmlElementContext) || window;

	const returnValue = useReturnToScroll(config?.isLoading || false, mainEl);

	useEffect(() => {
		if (config?.type === ConfigType.Basic) {
			mainEl?.scrollTo({ top: 0 });
		}
	}, [config?.type, mainEl]);

	return returnValue;
}
